import "react-app-polyfill/ie9";
import "resize-observer-polyfill/dist/ResizeObserver.global";
import { AppRegistry } from "react-native";
import "./index.css";
import AppRouter from "./AppRouter";

import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import "firebase/firestore";
import "firebase/storage";
import { useEffect, useState } from "react";
import * as React from "react";

const useFirebaseReady = () => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    (async () => {
      const response = await fetch("/__/firebase/init.json");
      if (!response.ok) {
        alert(response.statusText);
      }
      const json = await response.json();
      firebase.initializeApp(json);
    })()
      .then(() => setReady(true))
      .catch(error => {
        alert(error.message);
      });
  }, []);
  return ready;
};

const App = () => {
  const ready = useFirebaseReady();
  if (!ready) {
    return null;
  }
  return <AppRouter />;
};

AppRegistry.registerComponent("roqueAdmin", () => App);
AppRegistry.runApplication("roqueAdmin", {
  rootTag: document.getElementById("root")
});
